import { RootState } from "integrations/redux/rootReducer"
import { createSelector } from "@reduxjs/toolkit"
import { OrthoMask } from "@nova/protobuf"

const root = (state: RootState) => state.project.data.orthoMasks

export const selectOrthoMasks = (s: RootState) => root(s)

export const selectOrthoMasksMap = createSelector([selectOrthoMasks], (masks) =>
    masks.reduce(
        (acc, mask) => {
            acc[mask.id] = mask
            return acc
        },
        {} as Record<string, OrthoMask>
    )
)

const _byIdSelectors = new Map<string, (state: RootState) => OrthoMask | undefined>()
export const selectOrthoMaskById = (id: string) => {
    if (!_byIdSelectors.has(id)) {
        _byIdSelectors.set(
            id,
            createSelector([selectOrthoMasksMap], (map) => map[id] as OrthoMask | undefined)
        )
    }
    return _byIdSelectors.get(id)!
}

const _byFlightIdSelectors = new Map<string, (state: RootState) => OrthoMask | undefined>()
export const selectOrthoMaskByFlightId = (flightId: string) => {
    if (!_byFlightIdSelectors.has(flightId)) {
        _byFlightIdSelectors.set(
            flightId,
            createSelector(
                [selectOrthoMasks],
                (masks) => masks.find((m) => m.flightId === flightId) as OrthoMask | undefined
            )
        )
    }
    return _byFlightIdSelectors.get(flightId)!
}
